import { withVersions } from "v2/hocs/withVersions";
import DefinitionTooltipV1 from "./DefinitionTooltip/v1";
import DefinitionTooltipV2 from "./DefinitionTooltip/v2";

const DefinitionTooltip = withVersions({
  v1: DefinitionTooltipV1,
  v2: DefinitionTooltipV2,
});

export default DefinitionTooltip;
